import React from 'react';
import { Link } from 'react-router-dom';
import { researchArticles } from '../data/researchArticles';

const Research: React.FC = () => {
    return (
        <main id="main-content" className="w-full bg-canvas" role="main">
            {/* Page Title */}
            <section className="pt-32 pb-16 px-6 md:px-12 text-center">
                <h1 className="">
                    Research
                </h1>
            </section>

            {/* Research Section */}
            <section className="pb-24 px-6 md:px-12">
                <div className="bg-canvas-alt rounded-3xl p-12 md:p-16">
                    <div className="space-y-0">
                        {researchArticles.map((article) => (
                            <Link key={article.slug} to={`/research/${article.slug}`} className="group py-12 md:py-16 border-t border-border flex items-start justify-between gap-6 block transition-all duration-500">
                                <div className="flex-1 max-w-2xl">
                                    {article.date && (
                                        <p className="mb-4 text-sm tracking-[0.08em] text-text-secondary">
                                            {article.date}
                                        </p>
                                    )}
                                    <h2 className="mb-3 text-xl md:text-2xl font-medium tracking-tight">{article.title}</h2>
                                    <p className="text-balance leading-relaxed text-text-secondary">
                                        {article.description}
                                    </p>
                                </div>
                                <span className="text-2xl text-text-primary opacity-0 group-hover:opacity-100 group-hover:translate-x-2 transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)]">→</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Research;
